// MapControls.js
import React from 'react';
import { Box, Paper, ButtonGroup, Button } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import TerrainIcon from '@mui/icons-material/Terrain';
import SatelliteIcon from '@mui/icons-material/Satellite';

const mapTiles = {
  standard: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
    name: 'Standard',
    icon: MapIcon,
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Imagery &copy; Esri',
    name: 'Satellite',
    icon: SatelliteIcon,
  },
  terrain: {
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenTopoMap contributors',
    name: 'Terrain',
    icon: TerrainIcon,
  },
};

export const MapControls = ({ showControls, selectedMapType, setSelectedMapType }) => {
  if (!showControls) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 1000,
      }}
    >
      <Paper elevation={3}>
        <ButtonGroup orientation="vertical">
          {Object.entries(mapTiles).map(([key, value]) => {
            const Icon = value.icon;
            return (
              <Button
                key={key}
                onClick={() => setSelectedMapType(key)}
                variant={selectedMapType === key ? 'contained' : 'outlined'}
                startIcon={<Icon />}
                sx={{ px: 2 }}
              >
                {value.name}
              </Button>
            );
          })}
        </ButtonGroup>
      </Paper>
    </Box>
  );
};